<template>
	<!-- LSP-17328: rendered on the session page above the media search, with its own vertical space so it
	     never sits flush against the detail fields or the search field. EntityDetailPage mounts this in BOTH
	     layout branches — `mobile-info` and its `!isMobileLayout` sibling each own a copy of the search UI, so
	     a single mount inside one of them left desktop with no Send Reminder at all. Only one branch renders
	     at a time, so this is one live instance. Both mounts gate on `isAuthenticated` like the search beside
	     them: the POST requires auth, so an unauthenticated viewer would only get an error toast.
	     Session-level because one reminder covers every unfinished recording in the session; the lightbox
	     keeps a text-only notice for the individual recording.

	     F-02 residual: visibility and action are separate decisions. The admin always learns the upload is
	     unfinished; the Send Reminder control is only offered where the server says a reminder can actually be
	     sent (`canSendReminder`), because every send path answers a non-ASYNC conversation with 422. Otherwise
	     the same fact renders as a notice naming Resend Invitation, the alternative that works. Same shape
	     MediaLightBox already uses.

	     This lives in its own component because the two layout branches had the whole block — markup, copy and
	     both `v-test` selectors — transcribed verbatim. One copy is how the two branches stay identical. -->
	<IncompleteUploadBanner
		v-if="canSendReminder"
		:conversation-id="conversationId"
		:has-customer="hasCustomer"
		:pending-kind="pendingKind"
		class="my-3 pr-2" />
	<v-alert
		v-else
		type="warning"
		variant="tonal"
		density="compact"
		rounded="lg"
		class="my-3 pr-2"
		v-test="'session-incomplete-upload-notice'">
		{{ noticeMessage }}
	</v-alert>
</template>

<script setup lang="ts">
	import IncompleteUploadBanner from "@/components/IncompleteUploadBanner.vue";

	defineProps<{
		conversationId: string;
		/** A customer-recorded session reopens their own link; a self-recorded one is the user's own device. */
		hasCustomer: boolean;
		/** Which unfinished media the copy should speak about — see IncompleteUploadBanner. */
		pendingKind?: "recording" | "media";
		/** False when the server says no reminder can be sent for this conversation type; renders the fact-only notice. */
		canSendReminder: boolean;
		/** Copy for the fact-only notice, which names Resend Invitation as the alternative that does work. */
		noticeMessage: string;
	}>();
</script>
